import { Injectable, inject } from '@angular/core';
import { HttpMiddlewareService } from '../http/http-middleware.service';
import { NotificationService } from '../../../admin/_services/ui/notification.service';
import { Router } from '@angular/router';
import { Globals } from '../../globals.service';
import { HttpClient } from '@angular/common/http';
import { WorkStationData } from '../../../typescript/WorkStationData';
import { ListAvailableTimeSlotsParameters } from '../../../typescript/listAvailableTimeSlotsParameters';
import { CreateWorkStationDisplayData } from '../../../typescript/createWorkStationDisplayData';
import { UserRole } from '../../../typescript/userRole';

@Injectable({
  providedIn: 'root',
})
export class ArrivalService {
  private http = inject(HttpMiddlewareService);
  private notificationService = inject(NotificationService);
  private router = inject(Router);
  private globals = inject(Globals);
  private httpClient = inject(HttpClient);

  ENDPOINT = 'admin/api/arriving';

  public getworkReservation() {
    return this.http.get(this.globals.baseUrl + this.ENDPOINT + '/workReservation');
  }

  public patchSkip(id: number) {
    return this.http.patch(this.globals.baseUrl + this.ENDPOINT + '/workreservation/' + id + '/skip', null);
  }
  public patchArrived(id: number) {
    return this.http.patch(this.globals.baseUrl + this.ENDPOINT + '/workreservation/' + id + '/arrive', null);
  }
  public patchUnArrived(id: number) {
    return this.http.patch(this.globals.baseUrl + this.ENDPOINT + '/workreservation/' + id + '/unarrive', null);
  }

  public patchStartWork(id: number, work: WorkStationData) {
    return this.http.patch(this.globals.baseUrl + this.ENDPOINT + '/workreservation/' + id + '/startWork', work);
  }

  public patchBackToQUeue(id: number) {
    return this.http.patch(this.globals.baseUrl + this.ENDPOINT + '/workreservation/' + id + '/backtoqueue', null);
  }

  public patchDone(id: number) {
    return this.http.patch(this.globals.baseUrl + this.ENDPOINT + '/workreservation/' + id + '/done', null);
  }

  public patchDelete(id: number) {
    return this.http.delete(this.globals.baseUrl + 'admin/api/reservation/' + id);
  }

  public getAvailableTimeSlots(TSP: ListAvailableTimeSlotsParameters) {
    return this.http.post(this.globals.baseUrl + 'admin/api/appointment/listAvailableTimeSlots', TSP);
  }

  public createDisplay(Data: CreateWorkStationDisplayData) {
    return this.http.post(this.globals.baseUrl + this.ENDPOINT + '/createdisplay', Data);
  }

  public getDisplaydata(data: string) {
    return this.http.get(this.globals.baseUrl + this.ENDPOINT + '/displayData' + '/' + data);
  }
  public getAvailableTimeSlotsAdmin(parameters: ListAvailableTimeSlotsParameters) {
    return this.http.post(this.globals.baseUrl + '/admin/api/reservation/listAvailableTimeSlots', parameters);
  }
  public getAvailableTimeSlotsAdminSilent(parameters: ListAvailableTimeSlotsParameters) {
    const headers = this.globals.getRole().includes(UserRole.SUPERADMIN)
      ? this.globals.getSAHeaders()
      : this.globals.getHeaders();
    return this.httpClient.post(this.globals.baseUrl + '/admin/api/reservation/listAvailableTimeSlots', parameters, {
      headers,
    });
  }
  public getSelfCare(displaycode: string) {
    return this.http.get(this.globals.baseUrl + this.ENDPOINT + `/displayData/selfcare/${displaycode}`);
  }

  public putSelfcareArrival(referenceId: string) {
    return this.http.put(this.globals.baseUrl + this.ENDPOINT + `/display/arrive/${referenceId}`);
  }
}
